var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    className: "feather feather-home",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.80121 7.79902L11.0506 1.99951C11.781 1.41516 12.8189 1.41516 13.5494 1.99951L20.7988 7.79902C21.7476 8.55811 22.3 9.70737 22.3 10.9225V18C22.3 20.2091 20.5091 22 18.3 22H6.29999C4.09085 22 2.29999 20.2091 2.29999 18V10.9225C2.29999 9.70736 2.85235 8.55811 3.80121 7.79902Z",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d5f1432b.svg";
export { ForwardRef as ReactComponent };